import React from 'react';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Flex } from '@tq/ui-components';

export type NumberBoxProps = {
  label: number | string;
};

export const NumberBox: React.FC<NumberBoxProps> = ({ label }) => {
  return (
    <Flex
      h={6}
      w={6}
      mr={2}
      fontSize='sm'
      justifyContent='center'
      alignItems='center'
      float='left'
      borderRadius='50%'
      color={COLOURS.white}
      backgroundColor={COLOURS.black}
    >
      {label}
    </Flex>
  );
};
